import React from 'react';
import { FiSettings } from 'react-icons/fi';
import Icon, { IconProps } from '../Icon';

export interface OrganizationIconProps extends IconProps {}

const SettingsIcon: React.FC<OrganizationIconProps> = ({ ...props }) => {
  return <Icon as={FiSettings} {...props} />;
};

export default SettingsIcon;
